<div class="card-container none-alc-aux">
    
    <mat-card class="example-card table-container">
        
        <mat-card-header>
            <mat-card-title>Mantenimiento de contactos</mat-card-title>
            <mat-card-subtitle>Crea y modifica contactos a demanda</mat-card-subtitle>
        </mat-card-header>

        <div class="spinner" *ngIf="isLoading">
            <mat-spinner color="accent"></mat-spinner>
        </div>
        
        <mat-card-content>
            <form #formu (ngSubmit)="ac_sendForm()" autocomplete="off" [formGroup]="formulario">
                

                <mat-form-field appearance="fill" class="bt col-md-6 none-alc-aux">
                    <mat-label>Tipo de contacto</mat-label>
                    <mat-select formControlName="tipoContacto">
                        <mat-option value="">--- Seleccione una opción ---</mat-option>
                        <ng-container *ngFor="let tipo of tipoContactos">
                            <mat-option [value]="tipo.id">{{tipo.nombre}}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" class="bt col-md-6 none-alc-aux">
                    <mat-label>Nombre</mat-label>
                    <input matInput placeholder="" formControlName="nombre" maxlength="50">
                </mat-form-field>

                <mat-form-field appearance="fill" class="bt col-md-6 none-alc-aux">
                    <mat-label>Organización</mat-label>
                    <input matInput placeholder="" formControlName="organizacion" maxlength="100">
                </mat-form-field>

                <mat-form-field appearance="fill" class="bt col-md-6 none-alc-aux">
                    <mat-label>Cargo</mat-label>
                    <input matInput placeholder="" formControlName="cargo" maxlength="50">
                </mat-form-field>

                <mat-form-field appearance="fill" class="bt col-md-6 none-alc-aux">
                    <mat-label>Direccion</mat-label>
                    <input matInput placeholder="" formControlName="direccion" maxlength="100">
                </mat-form-field>

                <mat-form-field appearance="fill" class="bt col-md-3 none-alc-aux">
                    <mat-label>Teléfono</mat-label>
                    <input matInput placeholder="" formControlName="telefono" maxlength="10">
                </mat-form-field>
                <mat-form-field appearance="fill" class="bt col-md-3 none-alc-aux">
                    <mat-label>Extención</mat-label>
                    <input matInput placeholder="" formControlName="extencion" maxlength="10">
                </mat-form-field>

                <mat-form-field appearance="fill" class="bt col-md-6 none-alc-aux">
                    <mat-label>Correo electrónico</mat-label>
                    <input matInput placeholder="" formControlName="correo" maxlength="50">
                </mat-form-field>


                <mat-form-field appearance="fill" class="bt col-md-3 none-alc-aux">
                    <mat-label>Celular</mat-label>
                    <input matInput placeholder="" formControlName="celular" maxlength="10">
                </mat-form-field>


                <mat-form-field appearance="fill" class="bt col-md-12">
                    <mat-label>Observaciones</mat-label>
                    <input matInput placeholder="" formControlName="observaciones" maxlength="100">
                </mat-form-field>

                
                <mat-card-actions>
                    
                    <button type="submit" color="primary" mat-flat-button>Guardar</button>
                    &nbsp;
                    <a type="button" color="primary" mat-stroked-button [routerLink]="['/centro-informacion-institucional/directorio']">Cancelar</a>
                </mat-card-actions>
            </form>
            
        </mat-card-content>
        
    </mat-card>
</div>